import * as React from 'react'
import { FirestoreCollection, withFirestore } from 'react-firestore'
import MarketItems from './MarketItems'

class Shop extends React.Component {
	async buyItem(item) {
		const srnkaRef = this.props.firestore
			.collection('srnky')
			.doc(this.props.srnka.id)
		const srnka = (await srnkaRef.get()).data()
		if (srnka.money >= item.cost) {
			await srnkaRef.update({
				food: srnka.food + (item.addFood || 0),
				money: srnka.money - item.cost
			})
			alert(`Právě jsi koupil: ${item.title}`)
		} else {
			alert(`Nemáš dost peněz na ${item.title}`)
		}
	}

	render() {
		return (
			<FirestoreCollection
				path="items"
				render={({ isLoading, data }) =>
					isLoading ? null : (
						<MarketItems
							items={data
								.filter(
									item =>
										typeof item.available === 'boolean'
											? item.available
											: true
								)
								.map(item => ({
									buy: () => this.buyItem(item),
									disabled:
										item.cost > this.props.srnka.money,
									id: item.id,
									title: `${item.title} $${item.cost}`
								}))}
						/>
					)
				}
			/>
		)
	}
}

export default withFirestore(Shop)



// WEBPACK FOOTER //
// ./src/Shop.js